import React, { FC, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { BrowserRouter as Router, Route, Switch, useHistory } from "react-router-dom";
import '../../scss/styles.scss';
import { LoginForm } from "./LoginForm/LoginForm";

const LoginRedirect: FC = () => {
  const history = useHistory();
  useEffect(() => {
    history.replace('/login')
  })
  return null;
}

export const Login: FC = () => {
  return (
    <Container>
      <Row>
        <Col md={{ size: 4, offset: 4 }}>
          <Router >
            <Switch>
              <Route path="/login">
                <div className="mt-4">
                  <LoginForm />
                </div>
              </Route>
              <Route>
                <LoginRedirect />
              </Route>
            </Switch>
          </Router>
        </Col>
      </Row>
    </Container>
  );
};